import React, { Component, Suspense } from "react";
import axios from "axios";
import _ from "lodash";
import { Button, Row } from "reactstrap";
import {
  Menu,
  Segment,
  Sidebar,
  Pagination,
  Dropdown,
} from "semantic-ui-react";
import { connect } from "react-redux";
import { saveAs } from "file-saver";
import ContentWrapper from "../../template/Layout/ContentWrapper";
import { Link } from "react-router-dom";
import Loader from "../../Global/Loader";
import { withRouter } from "react-router-dom";
import { message, DatePicker, Skeleton, Button as ButtonAnt } from "antd";
import moment from "moment";
import { Services } from "../../../repositories/clients/Services";
import FormFiltros from "./model/form";
import queryString from "query-string";
import "./styles.scss";
import "./Components/styles/cards.scss";
import { withNamespaces } from "react-i18next";
import Cards from "../Components/Cards";
const Map = React.lazy(() => import("../Components//Maps/map"));
const Comments = React.lazy(() => import("../Components/Comments"));

const { RangePicker } = DatePicker;
class Trazabilidad extends Component {
  state = {
    isMovil: false,
    loadercomments: false,
    viewModalComments: false,
    searching: "0",
    commentsData: [],
    users: [],
    rolId: this.props._rolId,
    userId: this.props._user,
    scrollLine: false,
    rowid: "",
    extraElement: false,
    itemCommenSelect: {},
    // rolId: this.props._rolId,
    // userId: this.props._user,
    respladoCatalogCombo: {},

    map: (
      <Suspense fallback={<div>Loading...</div>}>
        <Map
          polylineData={[]}
          heidIcon={20}
          disableDefaultUI={true}
          // style={{ maxHeight: "300px" }}
          marker={[]}
          visible={true}
          type={"polylineDrawer"}
          data={[]}
          dataDrawer={""}
          // zoom={3}
        />
      </Suspense>
    ),
    // clientesSelect: clientSave.getAuthentication('client'),
    clientesSelect: this.props.clients
      ? JSON.stringify(this.props.clients)
      : "[0]",
    activePage: 1,
    limit: 10,
    catalogCombo: [],
    paramsxml: {},
    numberPage: 1,
    totalPages: 1,
    pages: 0,
    numberPageOrder: 1,
    activePageOrder: 1,
    totalPagesOrder: 1,
    searchOrder: "",
    isSearchsearchOrder: false,
    excelOrderLoading: false,
    limitOrder: 10,
    pagesOrder: 0,
    totalPagesExt: 1,
    search: "",
    isSearch: false,
    excelShipmentLoading: false,
    totalCard: [],
    dataDrawer: "",
    visible: false,
    selected: "",
    polyline: [],
    data: [],
    dataTable: [],
    // dataMap: mapJson.dataMap,
    dataAux: [],
    activePageAux: 1,
    dataOut: [],
    labelSelected: "",
    loading: true,
    graphs: [],
    markers: [],
    dataMap: [],
    donutChart: [],
    extraFilter: "",
    priorityChecked: false,
    config: [
      {
        title: this.props.t("status"),
        idExcel: "Status",
        xls: true,
        hide: true,
        header: { link: false, hide: true, icon: false },
        data: {
          link: false,
          progress: false,
          icon: false,
          status: false,
          hide: true,
        },
        id: "null",
        className: "hidden",
      },
      {
        title: "",
        xls: false,
        first: true,
        foot: { show: false, style: { fontSize: "12px", fontWeight: "bold" } },
        header: { link: false, hide: true, icon: false },
        data: { link: false, progress: false, icon: false, status: false },
        id: "ShipmentId",
        link: "/shipmentsDetal/",
        className: "col-xs-3 col-md-2 col-lg-1 p-0",
      },
      // {
      //   title: this.props.t("shipment_no"),
      //   xls: true,
      //   hide: true,
      //   id: "ShipmentNumber",
      //   className: "col-md-1 col-lg-1 col-sm-6",
      // },

      // {
      //   title: "Cliente",
      //   xls: true,
      //   foot: {
      //     show: false,
      //     style: { fontSize: "12px", fontWeight: "bold", color: "green" },
      //   },
      //   data: { link: false, progress: false, icon: false, status: false },
      //   header: { link: false },
      //   id: "CustomerName",
      //   link: "/shipmentsDetal/",
      //   className: "col-xs-1 col-md-1 col-lg-1 p-0",
      // },
      {
        title: this.props.t("shipment_no"),
        xls: true,
        foot: {
          show: false,
          style: { fontSize: "12px", fontWeight: "bold", color: "green" },
        },
        data: {
          link: false,
          progress: false,
          icon: false,
          status: false,
          custom: true,
        },
        header: { link: false, validateEvents: true },
        id: "ShipmentNumber",
        custom: (value) => (
          <div class="mb-mail-from">
            <center>
              <Link
                className="linkDetail"
                to={"/shipmentsDetail/" + value.ShipmentId}
              >
                {value.ShipmentNumber}
              </Link>
            </center>
          </div>
        ),
        className: "col-xs-3 col-md-2 col-lg-1 p-0",
      },
      {
        title: this.props.t("HBL_HAWB"),
        xls: true,
        icon: "fa-2x mr-2 fas fa-arrow-alt-circle-left",
        id: "HBL_HAWB",
        className: "col-xs-3 col-md-2 col-lg-1 p-0",
      },
      {
        title: this.props.t("customer"),
        xls: true,
        icon: "fa-2x mr-2 fas fa-arrow-alt-circle-left",
        id: "CustomerName",
        className: "col-xs-3 col-md-2 col-lg-1 p-0",
      },
      {
        title: this.props.t("shipper"),
        xls: true,
        id: "ShipperName",
        className: "col-xs-3 col-md-2 col-lg-1 p-0",
      },
      {
        title: this.props.t("consignee"),
        xls: true,
        type: 7,
        id: "ConsigneeName",
        className: "col-xs-3 col-md-2 col-lg-1 p-0",
      },
      {
        title: this.props.t("customer_reference"),
        xls: true,
        data: { link: false, progress: false, icon: false, status: false },
        id: "CustomertRef",
        className: "col-xs-3 col-md-2 col-lg-1 p-0",
      },

      {
        title: this.props.t("container_num"),
        xls: true,
        type: 7,
        id: "Containers",
        className: "col-xs-3 col-md-2 col-lg-1 p-0",
      },
      {
        title: this.props.t("origin"),
        xls: true,
        link: "/shipmentsDetal/",
        id: "POL",
        id2: "POLName",
        className: "col-xs-3 col-md-2 col-lg-1 p-0",
      },
      {
        title: this.props.t("destination"),
        xls: true,
        data: { link: false, progress: false, icon: false, status: false },
        link: "/shipmentsDetal/",
        id: "POD",
        id2: "PODName",
        className: "col-xs-3 col-md-2 col-lg-1 p-0",
      },

      // {
      //   title: "Ref. Consignatario",
      //   xls: true,
      //   type: 7,
      //   id: "ConsigneeRef",
      //   className: "col-md-2 col-lg-1 col-sm-1",
      // },
      // {
      //   title: "No Contenedor",
      //   xls: true,
      //   link: "/shipmentsDetal/",
      //   id: "RefCliente",
      //   className: "col-xs-1 col-md-1 col-lg-1 p-0",
      // },
      // {
      //   title: this.props.t("customer_references"),
      //   xls: true,
      //   data: { link: false, progress: false, icon: false, status: false },
      //   id: "CustomertRef",
      //   className: "col-md-3 col-lg-2 col-sm-6",
      // },
      {
        title: this.props.t("etd"),
        xls: true,
        hide: false,
        icon: "fa-2x mr-2 fas fa-arrow-alt-circle-left",
        colorLogo: "#643296c2",
        id: "ETDList",
        className: "col-xs-3 col-md-2 col-lg-1 p-0",
      },
      {
        title: this.props.t("eta"),
        xls: true,
        hide: false,
        icon: "fa-2x mr-2 fas fa-arrow-alt-circle-left",
        colorLogo: "#643296c2",
        id: "ETAList",
        className: "col-xs-3 col-md-2 col-lg-1 p-0",
      },
      {
        title: this.props.t("progress"),
        xls: false,
        data: { link: false, progress: true, icon: false, status: false },
        id: "Progress",
        className: "col-xs-3 col-md-2 col-lg-1",
      },
    ],

    advancedSearch2: FormFiltros,
    advancedSearch: [],
    advancedObj: [],
    advancedOrderObj: [],
    url: "",
    totalShipments: "",
  };

  componentDidMount = () => {
    let details = navigator.userAgent;
    let regexp = /android|iphone|kindle|ipad/i;
    let isMobileDevice = regexp.test(details);

    this.setState({
      isMovil: isMobileDevice,
    });
    let objSearch = queryString.parse(this.props.location.search);
    let searching = objSearch.searching ? objSearch.searching : "0";

    this.setState({ searching }, () => {
      this.getListShipments();
      this.getCatalogs();
      this.getMapShipments();
      this.resetAdvance();
    });
    window.addEventListener("resize", () => {
      let newGraphs = this.state.graphs;
      newGraphs.map((e) => {
        e.width = this.calculateWidth();
        return e;
      });
      this.setState({ graphs: newGraphs });
    });
  };

  getCommnets = (item, NewComments) => {
    let { CustomerId, ShipmentId } = item;

    let moduleId = 1;
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    axios
      .get(
        `${Services.TRACEABILITY.path}trazabilidad/get-comment?rowid=${ShipmentId}&moduleid=${moduleId}&general=false&zona=${timezone}&lang=${this.props.lng}`,
      )
      .then((response) => {
        let comentario = response.data.Comment;
        this.getUserMenciones(comentario, CustomerId, ShipmentId, item);

        if (NewComments) {
          message.success(NewComments);
        }
        // this.getUserMenciones(
        //   { commentsData: comentario,viewModalComments: true,
        //   }
        // );
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getUserMenciones = (comentario, CustomerId, ShipmentId, item) => {
    let { userId } = this.state;
    axios
      .get(
        `${Services.TRACEABILITY.path}trazabilidad/getUserMension?CustomerId=${CustomerId}&user=${userId}`,
      )
      .then((response) => {
        this.setState({
          commentsData: comentario,
          users: response.data.data,
          rowid: ShipmentId,
          itemCommenSelect: item,
          loadercomments: false,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  newMessage = async (data) => {
    let { userId, rowid, itemCommenSelect } = this.state;
    console.log("newMessage", data, userId, rowid);
    data.Rowid = rowid;
    data.UserId = userId;
    data.ModuleId = 1;

    if (data.Mentions.length > 0) {
      let uniq = [...new Set(data.Mentions)];
      data.Mentions = uniq;
    }

    axios
      .post(`${Services.TRACEABILITY.path}trazabilidad/add-comment`, data)
      .then((response) => {
        // message.success("Comentario agregado correctamente");
        this.getCommnets(
          itemCommenSelect,
          this.props.t("comment_successfully_saved"),
        );
      })
      .catch((error) => {
        console.log(error);
        // message.error("Error al mandar el comentario");
      });
  };

  deleteMessage = async (idDelete) => {
    let { itemCommenSelect } = this.state;

    axios
      .delete(
        `${Services.TRACEABILITY.path}trazabilidad/delete-comment/${idDelete}`,
      )
      .then((response) => {
        this.getCommnets(
          itemCommenSelect,
          this.props.t("comment_successfully_deleted"),
        );
        // message.success("Comentario eliminado correctamente");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getCatalogs = () => {
    let data = {
      client: this.state.clientesSelect,
      userId: this.props._user,
      lang: this.props.lng,
    };
    axios
      .post(`${Services.TRACEABILITY.path}trazabilidad/catalogShipment`, data)
      .then((success) => {
        let catalogCombo = success.data.data;
        if (catalogCombo["CatEventos"]) {
          catalogCombo["CatEventos"].forEach((ev) => {
            if (ev.key !== "0") {
              ev.icon = (
                <img
                  className="_imgdropdown"
                  height="20px"
                  width="20px"
                  src={
                    "https://magiclog.blob.core.windows.net/onboardpic/warning.png"
                  }
                  alt="img_drop"
                />
              );
            }
          });
        }
        this.setState(
          {
            catalogCombo,
          },
          () => {
            this.generateFilters();
            this.generateExtraFilter();
          },
        );
      })
      .catch((error) => {
        console.warn(error);
      });
  };

  getEventObject = (idSearching) => {
    let object = false;
    if (idSearching === "3") {
      object = {
        id: "EventsRequiresAttention",
        UseIN: false,
        value: [1],
      };
    }
    return object;
  };
  getListShipments = () => {
    let { searching } = this.state;
    let eventSearch = {};
    let advanced = this.state.advancedObj;
    this.setState({
      fullLoader: false,
    });

    if (searching !== "0") {
      eventSearch = this.getEventObject(searching);
      if (eventSearch) advanced = [...advanced, eventSearch];
    }
    let data = {
      client: this.state.clientesSelect,
      pag: this.state.numberPage,
      limit: this.state.limit,
      lang: this.props.lng,
      userId: this.state.userId,
      EsDTA: 0,
      search: this.state.search,
      advanced,
    };
    this.setState({
      url: encodeURI(
        `${Services.TRACEABILITY.path}trazabilidad/listShipments?search=${this.state.search}&limit=1000`,
      ),
      paramsxml: data,
    });
    // // axios.post(`${Services.Get_Traceability_Shipments.path}shipments/listShipments`, data, {params:{pag:this.state.numberPage,limit:this.state.limit, EsDTA:0, search: this.state.search}} ).then(success => {
    axios
      .post(`${Services.TRACEABILITY.path}trazabilidad/listShipments`, data)
      .then((success) => {
        let data = success.data.data.map((e) => {
          let TraspormodeId = 1;
          e.TraspormodeId = TraspormodeId;
          e.id = e.ShipmentNumber;
          return e;
        });
        this.setState({
          totalPages: success.data.totalPage,
          totalPagesExt: success.data.totalPage,
          data: data,
          dataAux: data,
          dataOut: data,
          fullLoader: true,
          totalShipments: (
            <>
              {" "}
              {success.data.data.length !== 0 ? (
                <b>
                  {this.currencyFormatter({
                    currency: "USD",
                    value: success.data.data[0].total,
                  })}{" "}
                  of{" "}
                  {this.currencyFormatter({
                    currency: "USD",
                    value: success.data.data[0].totalShip,
                  })}{" "}
                  results
                </b>
              ) : (
                ""
              )}
            </>
          ),
        });
      })
      .catch((error) => {
        console.warn(error);
      });
  };

  currencyFormatter({ currency, value }) {
    const formatter = new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
    });
    return formatter.format(value);
  }

  setAdvanced = (val) => {
    this.setState({ advancedObj: val }, () => {
      this.getListShipments();
    });
  };

  getMapShipments = () => {
    let data = {
      client: this.state.clientesSelect,
      userId: this.state.userId,
      lang: this.props.lng,
    };
    axios
      .post(`${Services.TRACEABILITY.path}trazabilidad/MapsShipments`, data)
      .then((success) => {
        let markers = [];
        let polylineData = [];

        success.data.data.map((e, index) => {
          if (
            e.POLLatitude &&
            e.POLLongitude &&
            e.PODLatitude &&
            e.PODLongitude
          ) {
            if (e.POLLatitude && e.POLLongitude) {
              let obj = {
                anchorX: 20,
                anchorY: 20,
                key: `${index}From`,
                title: this.props.t("origin"),
                name: e.ShipmentId,
                data: e,
                position: {
                  lat: e.POLLatitude,
                  lng: e.POLLongitude,
                },
                icon: {
                  url: "https://magiclog.blob.core.windows.net/onboardpic/onboard_marker.png",
                  // e.TransportMode === "AIR"

                  //   ? "https://fsposeidon.blob.core.windows.net/seacargopic/Transporte-Aereo-Mapa[1].png"
                  //   : e.TransportMode === "SEA"
                  //     ? "https://magiclog.blob.core.windows.net/onboardpic/sea_shipment.png"
                  //     : "https://fsposeidon.blob.core.windows.net/seacargopic/Transporte-Terrestre-Mapa[1].png",
                },
              };

              let position = {
                lat: Number(e.POLLatitude),
                lng: Number(e.POLLongitude),
              };
              polylineData.push(position);
              markers.push(obj);
            }
            if (e.PODLatitude && e.PODLongitude) {
              let obj = {
                key: `${index}To`,
                title: this.props.t("destination"),
                name: e.ShipmentId,
                anchorX: 20,
                anchorY: 20,
                data: e,
                position: {
                  lat: e.PODLatitude,
                  lng: e.PODLongitude,
                },
                icon: {
                  url: "https://magiclog.blob.core.windows.net/onboardpic/onboard_marker.png",
                  // e.TransportMode === "AIR"

                  //   ? "https://fsposeidon.blob.core.windows.net/seacargopic/Transporte-Aereo-Mapa[1].png"
                  //   : e.TransportMode === "SEA"
                  //     ? "https://magiclog.blob.core.windows.net/onboardpic/sea_shipment.png"
                  //     : "https://fsposeidon.blob.core.windows.net/seacargopic/Transporte-Terrestre-Mapa[1].png",
                },
              };
              let position = {
                lat: Number(e.PODLatitude),
                lng: Number(e.PODLongitude),
              };
              polylineData.push(position);
              markers.push(obj);
            }
          }
          return e;
        });

        this.setState(
          {
            markers: markers,
            dataMap: polylineData,
            polyline: polylineData,
            // fullLoader: true,
            // totalCard: totalCard,
          },
          () => {
            this.setState({
              map: (
                <Suspense fallback={<div>Loading...</div>}>
                  <Map
                    polylineData={this.state.polylineData}
                    heidIcon={20}
                    style={{ maxHeight: "300px" }}
                    marker={this.state.markers}
                    visible={true}
                    type={"polylineDrawer"}
                    data={this.state.polylineData}
                    dataDrawer={this.state.dataDrawer}
                    zoom={3}
                  />
                </Suspense>
              ),
              graphs: [
                {
                  title: "Operaciones por Modo de Transporte",
                  type: "pie",
                  data: this.state.donutChart,
                  width: this.calculateWidth(),
                  height: "280",
                },
                {
                  title: "Operaciones por Tráfico",
                  type: "pie",
                  data: this.state.donutChartTrafico,
                  width: this.calculateWidth(),
                  height: "280",
                },
                {
                  title: "Operaciones por Estatus",
                  type: "bar",
                  data: this.state.barTable,
                  width: this.calculateWidth(),
                  height: "280",
                  left: 120,
                },
              ],
            });
          },
        );
      })
      .catch((error) => {
        console.warn(error);
      });
  };

  changePage = (activePage) => {
    console.log("activePageOrder", activePage);
    this.setState(
      {
        fullLoader: false,
        numberPage: activePage,
        activePageAux: activePage,
        activePage: activePage,
      },
      () => {
        this.getListShipments();
      },
    );
  };

  handleChange = () => (event) => {
    let val = event.target.value;
    if (!this.state.isSearch) {
      this.setState({ isSearch: true }, () => {
        this.setState(
          {
            search: val,
            activePage: 1,
            activePageAux: 1,
            limit: 10,
            numberPage: 1,
            totalPages: 1,
          },
          () => {
            this.getListShipments();
          },
        );
      });
    }
  };

  newSearch = (val) => {
    if (val.length < 1) {
      this.setState(
        {
          search: val,
          isSearch: false,
          activePage: 1,
          activePageAux: 1,
          limit: 10,
          numberPage: 1,
          totalPages: 1,
        },
        () => {
          this.getListShipments();
        },
      );
    } else {
      if (val.length < this.state.search.length) {
        this.setState(
          {
            search: val,
            activePage: 1,
            activePageAux: 1,
            limit: 10,
            numberPage: 1,
            totalPages: 1,
          },
          () => {
            this.getListShipments();
          },
        );
      } else {
        this.setState({ search: val }, () => {
          this.getListShipments();
        });
      }
    }
  };

  calculateWidth = () => {
    if (window.innerWidth >= 1756) {
      return (window.innerWidth / 4.8).toString();
    } else {
      return (window.innerWidth / 5.5).toString();
    }
  };

  handleSelectedFile = (value) => {
    try {
      let out = this.searchSelected(value);
      this.setState({
        selected: value,
        data: [out],
        dataOut: [out],
        labelSelected: value,
        activePage: 1,
        totalPages: 1,
      });
    } catch (e) {
      console.log(e);
    }
  };

  searchSelected = (ID) => {
    let { dataAux } = this.state;
    let FOUND = dataAux.find((o) => o.id === ID);
    return FOUND;
  };
  toggleDrawerMap = (data) => (evt) => {
    if (evt) evt.preventDefault();

    this.handleSelectedFile(data.id);
    this.setState({ visible: true, dataDrawer: data }, () => {
      this.setState({
        map: (
          <Suspense fallback={<div>Loading...</div>}>
            <Map
              polylineData={this.state.polylineData}
              heidIcon={20}
              style={{ maxHeight: "300px" }}
              marker={this.state.markers}
              visible={true}
              type={"polylineDrawer"}
              data={this.state.polylineData}
              dataDrawer={this.state.dataDrawer}
              zoom={3}
            />
          </Suspense>
        ),
      });
    });
  };

  redirectTo = (id) => (evt) => {
    // evt.preventDefault();
    // this.props.history.push('/tracking/'+id)
  };

  resetTableCards = (evt) => {
    evt.preventDefault();
    let { dataAux, totalPagesExt, activePageAux } = this.state;
    this.setState(
      {
        data: _.cloneDeep(dataAux),
        dataOut: _.cloneDeep(dataAux),
        labelSelected: "",
        activePage: activePageAux,
        totalPages: totalPagesExt,
        dataDrawer: "",
      },
      () => {
        this.setState({
          map: (
            <Suspense fallback={<div>Loading...</div>}>
              <Map
                polylineData={this.state.polylineData}
                heidIcon={20}
                style={{ maxHeight: "300px" }}
                marker={this.state.markers}
                visible={true}
                type={"polylineDrawer"}
                data={this.state.polylineData}
                dataDrawer={this.state.dataDrawer}
                zoom={3}
                showDrawerInfo={false}
              />
            </Suspense>
          ),
        });
      },
    );
  };

  backres = (backResponse) => {
    this.setState({
      data: backResponse,
      dataAux: backResponse,
      dataOut: backResponse,
    });
  };
  resetAdvance = () => {
    let { advancedSearch2 } = this.state;
    advancedSearch2.forEach((advData) => {
      advData.values = [];
    });
    this.setState({ advancedSearch2 }, () => {
      this.findAdvanced();
      this.generateFilters();
    });
  };

  handleExtraFilter = (value) => {
    this.setState(
      { searching: value === "" ? "0" : value, fullLoader: false },
      () => {
        this.generateExtraFilter();
        this.getListShipments();
      },
    );
  };

  generateExtraFilter = () => {
    let { extraElement, searching, catalogCombo } = this.state;
    extraElement = (
      <Dropdown
        className="NewClass"
        onChange={(evt, { value }) => this.handleExtraFilter(value)}
        id={"extrafilter"}
        options={catalogCombo["CatEventos"]}
        selection
        floating
        fluid
        value={searching}
        allowAdditions
      />
    );
    this.setState({ extraElement });
  };

  generateFilters = (newCat) => {
    const { advancedSearch2, catalogCombo } = this.state;
    let Inputs = advancedSearch2.map((e, i) => {
      if (e.type === "Datetime")
        return (
          <div
            key={e.id}
            className={e.class}
            style={{ marginTop: 5, marginBottom: 5 }}
          >
            <label className="labelTitleAvancSearc">
              {this.props.t(e.label)} {e.undefined ? "!" : ""}
            </label>
            <RangePicker
              className="col-md-12"
              placeholder={[
                this.props.t("start_date"),
                this.props.t("end_date"),
              ]}
              value={
                Array.isArray(e.values)
                  ? e.values.length > 0
                    ? [
                        moment.utc(new Date(e.values[0].init)),
                        moment.utc(new Date(e.values[0].end)),
                      ]
                    : []
                  : []
              }
              style={{
                height: "36px",
                borderRadius: ".3em",
                borderColor: "#CCCCCC",
                // fontSize:'12px'
              }}
              id={e.id}
              onChange={this.handleChangeDatePicKer(e.id)}
              size="large"
              format={e.format}
            />
          </div>
        );
      else if (e.type === "multipleSelect")
        return (
          <div
            key={e.id}
            className={e.class}
            style={{ marginTop: 5, marginBottom: 5 }}
          >
            <label className="labelTitleAvancSearc">
              {this.props.t(e.label)} {e.undefined ? "!" : ""}
            </label>
            <Dropdown
              className="NewClass"
              onChange={(evt, { value }) =>
                this.handleChangeSelectMultiple(e.id, value)
              }
              id={e.id}
              options={catalogCombo[e.options]}
              clearable
              search
              selection
              floating
              fluid
              value={e.values}
              multiple
              allowAdditions
            />
          </div>
        );
      return undefined;
    });
    let NewInput = (
      <div>
        <div className="d-flex justify-content-end">
          <Button
            className="mr-3"
            onClick={this.findAdvanced}
            color="primary"
            style={{ width: "auto" }}
            title={this.props.t("apply_filter")}
          >
            {this.props.t("apply")}
          </Button>
          <em
            class="fa-2x mr-2 fas fa-eraser"
            style={{
              color: "#085fb0",

              cursor: "pointer",
            }}
            title={this.props.t("remove_filters")}
            onClick={this.resetAdvance}
          />
        </div>

        <div className="row">{Inputs}</div>
      </div>
    );

    this.setState({
      filtros: NewInput,
    });
  };

  handleChangeSelectMultiple = (id, value) => {
    let { advancedSearch2 } = this.state;
    for (let i = 0; i < advancedSearch2.length; i++) {
      const e = advancedSearch2[i];
      if (e.id === id) {
        e.values = value;
      }
    }

    this.setState({ advancedSearch2 }, () => {
      this.generateFilters();
      // this.findAdvanced();
    });
  };

  handleChangeDatePicKer = (name) => (event) => {
    let { advancedSearch2 } = this.state;

    try {
      if (event) {
        advancedSearch2.forEach((search) => {
          if (search.id === name) {
            search.values = [
              {
                init: event[0].format("YYYY-MM-DD"),
                end: event[1].format("YYYY-MM-DD"),
              },
            ];
          }
        });
        this.setState({ advancedSearch2 }, () => {
          this.generateFilters();
          // this.findAdvanced();
        });
      } else {
        advancedSearch2.forEach((search) => {
          if (search.id === name) {
            search.values = [];
          }
        });
        this.setState({ advancedSearch2 }, () => {
          this.generateFilters();
          // this.findAdvanced();
        });
      }
    } catch (ex) {
      console.log(ex);
    }
  };

  findAdvanced = () => {
    let obj = [];
    this.state.advancedSearch2.forEach((e) => {
      if (e.values && e.values.length > 0) {
        let newPush = {
          id: e.id2,
          UseIN: true,
          isDate: e.type === "Datetime" ? true : false,
          value: e.values,
        };
        obj.push(newPush);
      } else {
        obj.push({
          id: e.id,
          UseIN: false,
          value: e.value,
        });
      }
    });
    this.setState(
      {
        advancedObj: obj,
        numberPage: 1,
        activePage: 1,
        activePageAux: 1,
      },
      () => {
        this.getListShipments();
      },
    );
  };

  generateShipmentExcel = () => {
    this.setState({
      excelShipmentLoading: true,
    });

    let data = {
      client: this.state.clientesSelect,
      pag: this.state.numberPage,
      lang: this.props.lng,
      userId: this.state.userId,
      limit: this.state.limit,
      EsDTA: 0,
      search: this.state.search,
      advanced: this.state.advancedObj,
      allData: true,
    };

    this.setState({
      url: encodeURI(
        `${Services.TRACEABILITY.path}trazabilidad/listShipments?search=${this.state.search}&allData=true`,
      ),
      paramsxml: data,
    });
    // // axios.post(`${Services.Get_Traceability_Shipments.path}shipments/listShipments`, data, {params:{pag:this.state.numberPage,limit:this.state.limit, EsDTA:0, search: this.state.search}} ).then(success => {
    axios
      .post(`${Services.TRACEABILITY.path}trazabilidad/listShipments`, data)
      .then((success) => {
        let data = success.data.data;
        let dateNow = new Date();
        let titleDownload = `${this.props.t("shipment_list")}-${
          dateNow.getFullYear() +
          (dateNow.getMonth() + 1).toString().padStart(2, "0") +
          dateNow.getDate().toString().padStart(2, "0")
        }`;
        let info = {
          config: {},
        };

        let options = {
          headers: this.state.headers,
          keys: this.state.keys,
          image: {
            name: "obl",
          },
          sheetName: this.props.t("shipments"),
        };
        axios
          .post(`${Services.Dowload_Excel.path}/report/dynamic/xlsx`, {
            info,
            data,
            options,
          })
          .then((success) => {
            if (success.data.base64) {
              const fileName = titleDownload + ".xlsx";
              const linkSource = `data:application/xlsx;base64,${success.data.base64}`;
              saveAs(linkSource, fileName);
              this.setState({
                excelShipmentLoading: false,
              });
            } else console.warn("Error downloading file", success);
          });
      })
      .catch((error) => {
        console.warn(error);
      });
  };

  setShipmentSearch = (name, value) => {
    this.setState(
      {
        search: value,
        activePage: 1,
        activePageAux: 1,
        numberPage: 1,
      },
      () => {
        this.getListShipments();
      },
    );
  };

  loadTab = (evt) => {};

  render() {
    let {
      fullLoader,
      viewModalComments,
      commentsData,
      users,
      rolId,
      userId,
      scrollLine,
      loadercomments,
      itemCommenSelect,
      totalShipments,
      isMovil,
      data,
    } = this.state;

    return (
      <ContentWrapper>
        <Loader hidden={fullLoader}></Loader>
        <div className="content-heading">
          <legend className="legendBasic">
            {/* <img
              style={{ margin: "-6px 6px 1px" }}
              alt=""
              src="https://magiclog.blob.core.windows.net/europartnerspic/Icono_trazabilidad-de-embarques.svg"
              height="28"
              width="28"
            ></img> */}
            <i className="icon-10abr23-iconosmagicdome-06_"></i>
            {this.props.t("shipments")}
          </legend>
        </div>

        {/* <Col lg={12} md={12}> */}
        {this.state.map}

        <br></br>

        <Row>
          <div className="col-12 p-0">
            <Suspense fallback={<div>Loading...</div>}>
              <Sidebar.Pushable
                as={Segment}
                className="listado-trazabilidad"
                style={{ border: "none", boxShadow: "none" }}
              >
                <Sidebar
                  as={Menu}
                  animation="overlay"
                  icon="labeled"
                  style={{
                    maxHeight: "84%!important",
                    width: isMovil
                      ? window.innerWidth - window.innerWidth * 0.1
                      : 400,
                  }}
                  // style={{ maxHeight: "84%!important" }}
                  direction="right"
                  // onHide={() => setVisible(false)}
                  vertical
                  id="sidebarComents"
                  visible={viewModalComments}
                  // width={window.innerWidth < 993 ? 'wide' : 'very wide'}
                >
                  <div className=" col-12 close_container">
                    <div className="header_comments">
                      {itemCommenSelect ? itemCommenSelect.ShipmentNumber : ""}
                    </div>
                    <div
                      className="close_icon2"
                      // style={{ marginTop: '8px !important' }}

                      onClick={() => {
                        console.log("cerrar");

                        this.setState({ viewModalComments: false });
                      }}
                    >
                      <ButtonAnt size="small" type="primary" shape="circle">
                        X
                      </ButtonAnt>
                    </div>
                  </div>
                  <div style={{ height: "3em" }} className=" col-12">
                    {" "}
                  </div>

                  {loadercomments === true ? (
                    <Skeleton active paragraph={{ rows: 17 }} />
                  ) : (
                    <div className=" col-12">
                      <Comments
                        commentTableList={true}
                        rolId={rolId}
                        userId={userId}
                        data={commentsData}
                        catalogs={users}
                        scrollLine={scrollLine}
                        funtionNewMessage={this.newMessage}
                        funtionDeleteMessage={this.deleteMessage}
                      />
                    </div>
                  )}
                </Sidebar>
                <Sidebar.Pusher>
                  <Segment basic>
                    <Cards
                      paramsxml={this.state.paramsxml}
                      clientesSelect={this.state.clientesSelect}
                      advancedSearch={(val) => {
                        this.setAdvanced(val);
                      }}
                      advancedSearchData={this.state.advancedSearch}
                      urlReport={this.state.url}
                      newSearch={(value) => {
                        this.newSearch(value);
                      }}
                      panel={true}
                      filtrosPanel={this.state.filtros}
                      resetAdvance={() => {
                        this.resetAdvance();
                      }}
                      pagination={false}
                      broswer={true}
                      config={this.state.config}
                      headerCard={this.state.headerCard}
                      toggleDrawer={this.toggleDrawerMap}
                      visible={this.state.visible}
                      data={this.state.dataOut}
                      dataSearch={this.state.data}
                      reset={this.resetTableCards}
                      labelStatus={this.state.labelSelected}
                      backRes={this.backres}
                      extraElement={this.state.extraElement}
                      xlsxConf={{
                        nameXlsx: `${this.props.t("shipment_list") + "-" + moment(new Date()).format("YYYYMMDD") + ".xlsx"}`,

                        sheetName: this.props.t("shipment_list"),
                      }}
                      totalShipments={totalShipments}
                    ></Cards>
                  </Segment>
                  {/* </div> */}
                  {data[0] ? (
                    data[0].total !== "0" ? (
                      <div className="col-12">
                        <center>
                          <Pagination
                            ellipsisItem={null}
                            activePage={this.state.activePage}
                            siblingRange={0}
                            size={"mini"}
                            // size={window.innerWidth < 993 ? 'mini' : ''}
                            // firstItem={null}
                            // lastItem={null}
                            // pointing
                            // secondary
                            totalPages={this.state.totalPages}
                            onPageChange={(e, { activePage }) => {
                              this.changePage(activePage);
                            }}
                          />
                        </center>
                      </div>
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}
                </Sidebar.Pusher>
              </Sidebar.Pushable>
            </Suspense>
          </div>
        </Row>
        {/* </Col> */}
      </ContentWrapper>
    );
  }
}
const mapStateToProps = (state) => ({
  clients: state.header.clients,
});
const mapDispatchToProps = () => ({});
export default withNamespaces()(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(Trazabilidad)),
);
